import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation TransferActivity($activityId: String!, $requestTypeId: Int, $comment: String, $operatorId: ID) {
  transferActivity(id: $activityId, requestTypeId: $requestTypeId, comment: $comment, operatorId: $operatorId) {
    id
    state
    appealId
    requestType {
      id
      name
      description
      defaultType
      active
    }
    case {
      id
      name
      description
      insertedAt
      updatedAt
      comment
    }
    comment
    isAuthorized
    noAuthorized
  }
}`;

function transferActivity(activityId, requestTypeId, comment, operatorId) {
  return apollo.client.mutate({
    variables: {
      activityId,
      requestTypeId: parseInt(requestTypeId, 10),
      comment,
      operatorId: parseInt(operatorId, 10),
    },
    mutation,
  }).then((res) => res.data.transferActivity);
}

export default transferActivity;
